import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { updateFields, updateFormProperties } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import InputCaptcha from 'apps/auth/components/form/InputCaptcha';
import InputPhoneWithDropdown from 'apps/auth/components/form/InputPhoneWithDropdown';
import InputsConfirmPassword from 'apps/auth/components/form/InputsConfirmPassword';
import Form from 'apps/auth/components/form-multi/Form';
import { getCaptchaURL } from 'apps/auth/components/form-multi/utils';
import { CAPTCHA, PASSWORD, PHONE } from 'apps/auth/constants/Constants';
import { RESTORE_PASSWORD_ACTION } from 'apps/auth/constants/UrlConstants';

const RestorePassword = (props) => {
    const [captchaURL, setCaptchaUrl] = useState(getCaptchaURL());

    const [iso2, updateIso2] = useState(props.loginCountryCode || props.defaultCountry);

    useEffect(() => {
        if (props.defaultCountry && !props.loginCountryCode) {
            updateIso2(props.defaultCountry);
        }
    }, [props.defaultCountry, props.loginCountryCode]);

    useEffect(() => {
        const fields = {};
        fields.phone = props.fields.phone;
        fields.phone.mandatory = true;
        fields.phone.visible = true;
        fields.phone.name = PHONE;

        fields.password = props.fields.password;
        fields.password.mandatory = true;
        fields.password.visible = true;
        fields.password.name = PASSWORD;

        fields.confirmPassword = props.fields.confirmPassword;
        fields.confirmPassword.mandatory = true;
        fields.confirmPassword.visible = true;

        fields.captcha = props.fields.captcha;
        fields.captcha.name = CAPTCHA;
        fields.captcha.mandatory = true;
        fields.captcha.visible = true;

        props.updateFields(props.formName, fields);
        props.updateFormProperties(props.formName, RESTORE_PASSWORD_ACTION);
    }, []);

    const submitHandler = (fields, json) => {
        if (json && json.errors && Object.keys(json.errors).length > 0) {
            setCaptchaUrl(getCaptchaURL());
        }
    };

    return (
        <>
            <HeaderPanel title={props.headerTitle} subtitle={props.headerGrayTitle} />
            <Form
                id="restorepassword_form_id"
                action={RESTORE_PASSWORD_ACTION}
                checkNotVisibleField={false}
                formName={props.formName}
                onSubmitHandler={submitHandler}
            >
                <Row indent="adaptive-24-32">
                    <Row indent="24px">
                        <InputPhoneWithDropdown field={props.fields.phone} formName={props.formName} iso2={iso2} isNonEditableCountry />
                    </Row>
                    <Row>
                        <InputsConfirmPassword formName={props.formName} password={props.fields.password} confirmPassword={props.fields.confirmPassword} />
                    </Row>
                </Row>
                <Row indent="adaptive-24-32">
                    <InputCaptcha field={props.fields.captcha} formName={props.formName} captchaURL={captchaURL} />
                </Row>
                <Row flex justify="center">
                    <Button type="submit" caption={props.button} />
                </Row>
            </Form>
        </>
    );
};

const mapStateToProps = ({ form, messages, extra, app, language, login }, ownProps) => {
    return {
        fields: form[ownProps.formName].fields,
        button: messages.pageMessages.button,
        restorePassRecommendation: messages.pageMessages.restorePassRecommendation,
        restorePassMinLength: messages.pageMessages.restorePassMinLength,
        restorePassLetters: messages.pageMessages.restorePassLetters,
        restorePassDigits: messages.pageMessages.restorePassDigits,
        restorePassSameCheck: messages.pageMessages.restorePassSameCheck,
        headerTitle: messages.pageMessages.headerTitle,
        headerGrayTitle: messages.pageMessages.headerGrayTitle,
        country: app?.country,
        lang: language?.lang,
        defaultCountry: extra.defaultCountry,
        loginCountryCode: login.countryCode,
    };
};
export default connect(mapStateToProps, { toggleSpinner, updateFields, updateFormProperties })(RestorePassword);
